/* Mobile-only buy-bar coordination. Desktop controllers retain their own behavior. */
(function () {
  'use strict';
  if (window.LplMobileSticky) return;
  var doc = document, phone = matchMedia('(max-width: 749px)'), bars = [], observed = new Map();
  var frame = 0, dirty = true, overlayDirty = true, overlayOpen = false, active = null, visibilityDirty = false;
  var bodyPadding = null, lastPadding = '', resizeObserver;
  var overlays = '[aria-modal="true"],[role="dialog"],dialog,cart-drawer,.drawer,menu-drawer details,header-drawer details,.search-modal,[data-lpl-ia-modal],.ingredients-modal,.mwp__modal-with-pages';
  var blockerSelector = 'footer,.shopify-section-group-footer-group,.product-form__submit,.pdp__btn-submit,.lpl-po__submit,.lpl-r-product .lpl-r-button,.lpl-pb-product .lpl-pb-button,.lpl-palat__shop';
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  function shown(node) {
    if (!node || !node.isConnected || node.closest('[hidden],[inert],[aria-hidden="true"]')) return false;
    var cs = getComputedStyle(node);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) !== 0;
  }
  function geometry(node, ready) {
    var rect = node.getBoundingClientRect();
    var inView = rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
    return {ready: ready === true, inView: inView, intersects: inView && shown(node), bottom: rect.bottom + scrollY, past: rect.bottom <= 0};
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      observed.set(entry.target, {ready: true, inView: entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0, intersects: entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0 && shown(entry.target), bottom: entry.boundingClientRect.bottom + scrollY, past: entry.boundingClientRect.bottom < 0});
    });
    schedule();
  }, {threshold: [0, 0.01]}) : null;
  function watch(node) {
    if (!node || observed.has(node)) return;
    // Seed from the current viewport; a delayed observer callback must not hold every bar closed.
    observed.set(node, geometry(node));
    if (io) io.observe(node);
  }
  function refresh() {
    dirty = false;
    var nodes = Array.from(doc.querySelectorAll('[data-lpl-mobile-sticky]'));
    bars = nodes.map(function (node) {
      var link = node.querySelector('a[href]'), productPath = '';
      try { if (link) productPath = new URL(link.href, location.href).pathname.replace(/\/+$/, ''); } catch (_) {}
      var blockers = Array.from(doc.querySelectorAll(blockerSelector)).filter(function (el) { return !el.closest('[data-lpl-mobile-sticky]'); });
      if (productPath) doc.querySelectorAll('main a[href]').forEach(function (el) {
        if (el.closest('[data-lpl-mobile-sticky],.bp__aside')) return;
        try { if (new URL(el.href, location.href).pathname.replace(/\/+$/, '') === productPath) blockers.push(el); } catch (_) {}
      });
      var kind = node.dataset.lplMobileSticky;
      var trigger = kind === 'pdp' ? (doc.querySelector('.lpl-po') || doc.querySelector('.product-form__buttons')) : kind === 'site' ? doc.getElementById(node.id.replace('LplWhatSticky-', 'LplWhatStickySentinel-')) : null;
      blockers.forEach(watch); watch(trigger);
      if (trigger) { observed.set(trigger, geometry(trigger, observed.get(trigger)?.ready)); if (resizeObserver) resizeObserver.observe(trigger); }
      if (resizeObserver) resizeObserver.observe(node);
      return {node: node, link: node.querySelector('.lpl-what-sticky__button'), kind: kind, trigger: trigger, blockers: blockers, height: Math.ceil(node.getBoundingClientRect().height)};
    });
    var keep = new Set(); bars.forEach(function (bar) { bar.blockers.forEach(function (n) { keep.add(n); }); if (bar.trigger) keep.add(bar.trigger); });
    observed.forEach(function (_, node) { if (!keep.has(node)) { if (io) io.unobserve(node); observed.delete(node); } });
  }
  function checkOverlay() {
    overlayDirty = false;
    overlayOpen = /(?:^|\s)(?:overflow-hidden(?:-mobile)?|modal-open|drawer-open|lpl-popup-open)(?:\s|$)/.test(doc.body.className);
    if (overlayOpen) return;
    overlayOpen = Array.from(doc.querySelectorAll(overlays)).some(function (node) {
      if (node.closest('[data-lpl-mobile-sticky]')) return false;
      if (node.tagName === 'DETAILS' || node.tagName === 'DIALOG') return node.open;
      if (node.matches('cart-drawer,.drawer')) return node.classList.contains('active') || node.classList.contains('is-open');
      if (node.matches('.mwp__modal-with-pages') && node.classList.contains('is-hide-modal-with-pages')) return false;
      if (!shown(node)) return false;
      var rect = node.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight;
    });
  }
  function typing() {
    var focused = doc.activeElement;
    if (focused && (focused.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(focused.tagName))) return true;
    var vv = window.visualViewport;
    return Boolean(vv && vv.scale < 1.15 && innerHeight - vv.height - vv.offsetTop > 150);
  }
  function setVisible(bar, visible) {
    var node = bar.node;
    if (node.classList.contains('is-visible') !== visible) node.classList.toggle('is-visible', visible);
    if (node.inert === visible) node.inert = !visible;
    if (node.getAttribute('aria-hidden') !== String(!visible)) node.setAttribute('aria-hidden', String(!visible));
    var link = bar.link;
    if (link && link.tabIndex !== (visible ? 0 : -1)) link.tabIndex = visible ? 0 : -1;
  }
  function resetPadding() {
    if (bodyPadding !== null) {
      if (bodyPadding.value) doc.body.style.setProperty('padding-bottom', bodyPadding.value, bodyPadding.priority);
      else doc.body.style.removeProperty('padding-bottom');
      bodyPadding = null; lastPadding = '';
    }
    if (doc.body.classList.contains('lpl-mobile-sticky-on')) doc.body.classList.remove('lpl-mobile-sticky-on');
    if (doc.documentElement.style.getPropertyValue('--lpl-mobile-sticky-height')) doc.documentElement.style.removeProperty('--lpl-mobile-sticky-height');
  }
  function update() {
    frame = 0;
    if (dirty) refresh();
    if (!phone.matches) {
      resetPadding();
      if (active !== null) {
        active = null;
        bars.forEach(function (bar) { bar.node.removeAttribute('inert'); bar.node.dispatchEvent(new Event('lpl:sticky-resume')); });
      }
      return;
    }
    if (active === null) active = false;
    if (overlayDirty) checkOverlay();
    if (visibilityDirty) { observed.forEach(function (state, node) { if (state.ready) state.intersects = Boolean(state.inView && shown(node)); else observed.set(node, geometry(node)); }); visibilityDirty = false; }
    // Until the first observer callback, fast scrolling must update seeded blocker positions too.
    observed.forEach(function (state, node) { if (!io || !state.ready) observed.set(node, geometry(node, !io)); });
    var suppressed = overlayOpen || typing(), chosen = null;
    bars.forEach(function (bar) {
      // One current boundary read avoids stale positions after gallery, font or option-layout changes.
      var past = bar.trigger ? bar.trigger.getBoundingClientRect().bottom <= 0 : scrollY > Math.max(560, innerHeight * 0.85);
      var eligible = bar.node.dataset.displayMode !== 'desktop' && (bar.kind !== 'pdp' || bar.node.dataset.lplPurchaseReady === 'true');
      var blocked = bar.blockers.some(function (node) { return observed.get(node)?.intersects; });
      if (!chosen && !suppressed && eligible && past && !blocked) chosen = bar;
    });
    // Measure before visibility/style writes. Fixed bars retain layout while offscreen.
    var height = chosen ? chosen.height : 0;
    if (chosen && bodyPadding === null) bodyPadding = {value: doc.body.style.getPropertyValue('padding-bottom'), priority: doc.body.style.getPropertyPriority('padding-bottom'), base: parseFloat(getComputedStyle(doc.body).paddingBottom) || 0};
    bars.forEach(function (bar) { setVisible(bar, bar === chosen); });
    if (chosen && height) {
      var padding = (bodyPadding.base + height) + 'px';
      if (padding !== lastPadding) { doc.body.style.setProperty('padding-bottom', padding, 'important'); lastPadding = padding; }
      if (!doc.body.classList.contains('lpl-mobile-sticky-on')) doc.body.classList.add('lpl-mobile-sticky-on');
      if (doc.documentElement.style.getPropertyValue('--lpl-mobile-sticky-height') !== height + 'px') doc.documentElement.style.setProperty('--lpl-mobile-sticky-height', height + 'px');
    } else resetPadding();
  }
  function reconcile() { dirty = overlayDirty = visibilityDirty = true; schedule(); }
  function start() {
    if ('ResizeObserver' in window) resizeObserver = new ResizeObserver(function (entries) { entries.forEach(function (entry) { var bar = bars.find(function (item) { return item.node === entry.target; }); if (bar) bar.height = Math.ceil(entry.borderBoxSize?.[0]?.blockSize || entry.target.getBoundingClientRect().height); else if (observed.has(entry.target)) visibilityDirty = true; }); schedule(); });
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        var target = record.target;
        if (target.closest?.('[data-lpl-mobile-sticky]')) return;
        if (record.type === 'childList') {
          if (Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (n) { return n.nodeType === 1 && !/^(SCRIPT|STYLE|LINK)$/.test(n.tagName); })) dirty = overlayDirty = true;
        } else {
          observed.forEach(function (_, node) { if (target === node || target.contains?.(node)) visibilityDirty = true; });
          if (target === doc.body || target === doc.documentElement || target.matches?.(overlays) || target.closest?.(overlays)) overlayDirty = true;
        }
      });
      if (dirty || overlayDirty || visibilityDirty) schedule();
    }).observe(doc.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden', 'open', 'aria-hidden', 'style']});
    addEventListener('scroll', schedule, {passive: true});
    addEventListener('resize', function () { dirty = overlayDirty = true; schedule(); }, {passive: true});
    if (phone.addEventListener) phone.addEventListener('change', schedule); else phone.addListener(schedule);
    ['focusin', 'focusout', 'toggle', 'shopify:section:load', 'shopify:section:unload'].forEach(function (name) { doc.addEventListener(name, function () { overlayDirty = true; if (name.indexOf('shopify:') === 0) dirty = true; schedule(); }, true); });
    if (window.visualViewport) { visualViewport.addEventListener('resize', schedule, {passive: true}); visualViewport.addEventListener('scroll', schedule, {passive: true}); }
    schedule();
  }
  window.LplMobileSticky = {schedule: schedule, refresh: function () { dirty = overlayDirty = true; schedule(); }};
  // This asset is requested after bar markup, so body and the initial bar already exist.
  if (doc.body) start(); else doc.addEventListener('DOMContentLoaded', start, {once: true});
  // Discover later parsed sections and recheck restored scroll / final stylesheet layout.
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', reconcile, {once: true});
  addEventListener('pageshow', reconcile);
  addEventListener('load', reconcile, {once: true});
})();
